import React, { Component } from 'react';
import './add-patient.css';
import { iconSend, iconSent } from '../assets';
import { BasePrimaryButton, PrimaryButton } from '../base-components';
import { strings as _strings } from '../lib';
const strings = _strings.addPatient;

export const InviteStates = Object.freeze({
  UNSENT: 'unsent',
  SENDING: 'sending',
  SENT: 'sent'
});

export default class AddPatient extends Component {

  static propTypes = {
    onSendSms: React.PropTypes.func.isRequired,
    onSendEmail: React.PropTypes.func.isRequired,
    smsState: React.PropTypes.oneOf(Object.values(InviteStates)).isRequired,
    emailState: React.PropTypes.oneOf(Object.values(InviteStates)).isRequired
  };

  static InviteStates = InviteStates;

  // TODO: move to redux state
  constructor() {
    super();
    this.state = {
      firstName: null,
      lastName: null,
      phoneNumber: null,
      emailAddress: null
    };
  }
  
  render() {
    return (
      <div className="add-patient-container">
        <p className="text-input-label">
          {strings.nameLabel}
        </p>
        {this.renderTextInput(this.state.firstName, (event) => this.setState({ firstName: event.target.value }), strings.firstNamePlaceholder)}
        {this.renderTextInput(this.state.lastName, (event) => this.setState({ lastName: event.target.value }), strings.lastNamePlaceholder)}
        <p className="text-input-label">
          {strings.smsLabel}
        </p>
        {this.renderSubmittableTextInput(this.state.phoneNumber,
                                         (event) => this.setState({ phoneNumber: event.target.value }),
                                         this.onSendSms,
                                         strings.phoneNumberPlaceholder,
                                         this.props.smsState,
                                         this.isSmsValid())}
        <p className="text-input-label">
          {strings.emailLabel}
        </p>
        {this.renderSubmittableTextInput(this.state.emailAddress,
                                         (event) => this.setState({ emailAddress: event.target.value }),
                                         this.onSendEmail,
                                         strings.emailPlaceholder,
                                         this.props.emailState,
                                         this.isEmailValid())}
        {this.props.emailState === InviteStates.SENT || this.props.smsState === InviteStates.SENT
         ? (
           <PrimaryButton title={'Done'}
                          onPress={this.props.onDone} />
         )  : null}
       </div>
    );
  }

  renderTextInput(val, onChange, placeholder) {
    return (
      <div className="add-patient-input-container">
        <input type="text"
               className="add-patient-input"
               placeholder={placeholder}
               value={val}
               onChange={onChange} />
      </div>
    );
  }

  renderSubmittableTextInput(val, onChange, onSubmit, placeholder, submitState, valid) {
    return (
      <div className="add-patient-input-container"
           style={{ paddingLeft: 50  }}>
        <input type="text"
               className="add-patient-input"
               placeholder={placeholder}
               value={val}
               onChange={onChange} />
        {submitState === InviteStates.SENT ? (
            <div className="send-btn-container">
              <img src={iconSent} />
            </div>
          ) : (
            <div className="send-btn-container">
              <BasePrimaryButton style={{ width: '100%', height: '100%' }}
                                 onPress={onSubmit}
                                 disabled={!valid} >
                <img src={InviteStates.UNSENT ? iconSend : null} />
              </BasePrimaryButton>
            </div>
        )}
      </div>
    );
  }

  _isValid = () => {
    return this.state.firstName && this.state.lastName;
  };

  isEmailValid = () => {
    return this._isValid() &&
      this.state.emailAddress &&
      this.state.emailAddress.includes('@');
  };

  isSmsValid = () => {
    return this._isValid() &&
      this.state.phoneNumber &&
      this.state.phoneNumber.length >= 10;
  };

  onSendSms = () => {
    this.props.onSendSms({
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      phoneNumber: this.state.phoneNumber
    });
  };

  onSendEmail = () => {
    this.props.onSendEmail({
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      emailAddress: this.state.emailAddress
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/add-patient.js